/* ============================================================
   BONA FIDE FLOWER — theme.js
   All modules wrapped in IIFEs, initialised on DOMContentLoaded
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ----------------------------------------------------------
     1. Mobile Nav Drawer
     window.bffToggleDrawer()
  ---------------------------------------------------------- */
  (function () {
    var drawer   = document.getElementById('mobileDrawer');
    var hamburger = document.querySelector('.hamburger');

    window.bffToggleDrawer = function () {
      if (!drawer) return;

      var isOpen = drawer.classList.contains('is-open');

      drawer.classList.toggle('is-open', !isOpen);
      if (hamburger) {
        hamburger.classList.toggle('is-open', !isOpen);
        hamburger.setAttribute('aria-expanded', String(!isOpen));
      }

      document.body.style.overflow = isOpen ? '' : 'hidden';
    };

    /* Close drawer on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        window.bffToggleDrawer();
      }
    });
  })();


  /* ----------------------------------------------------------
     2. Mobile Accordion Nav
     window.bffToggleAcc(btn)
  ---------------------------------------------------------- */
  (function () {
    window.bffToggleAcc = function (btn) {
      if (!btn) return;
      var subList = btn.nextElementSibling;
      if (!subList) return;

      var isOpen = subList.classList.contains('is-open');
      subList.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    };
  })();


  /* ----------------------------------------------------------
     3. Mega Menu
     window.bffToggleMega(e)
  ---------------------------------------------------------- */
  (function () {
    var openMega = null;

    window.bffToggleMega = function (e) {
      if (!e) return;
      e.stopPropagation();

      var trigger = e.currentTarget;
      var mega    = trigger ? trigger.nextElementSibling : null;
      if (!mega || !mega.classList.contains('mega-menu')) return;

      var isOpen = mega.classList.contains('is-open');

      /* Close any other open mega */
      if (openMega && openMega !== mega) {
        openMega.classList.remove('is-open');
        var prevTrigger = openMega.previousElementSibling;
        if (prevTrigger) prevTrigger.setAttribute('aria-expanded', 'false');
      }

      mega.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
      openMega = isOpen ? null : mega;
    };

    /* Close on outside click */
    document.addEventListener('click', function () {
      if (openMega) {
        openMega.classList.remove('is-open');
        var trigger = openMega.previousElementSibling;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        openMega = null;
      }
    });

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openMega) {
        openMega.classList.remove('is-open');
        var trigger = openMega.previousElementSibling;
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
        openMega = null;
      }
    });
  })();


  /* ----------------------------------------------------------
     4. Hero Carousel
     Finds all .hero-section elements and initialises each
  ---------------------------------------------------------- */
  (function () {
    var heroes = document.querySelectorAll('.hero-section');

    heroes.forEach(function (hero) {
      var slides  = hero.querySelectorAll('.hero-slide');
      var dots    = hero.querySelectorAll('.hero-dot');
      var prevBtn = hero.querySelector('.hero-arrow--prev');
      var nextBtn = hero.querySelector('.hero-arrow--next');

      if (!slides.length) return;

      var current  = 0;
      var total    = slides.length;
      var timer    = null;
      var INTERVAL = 5000;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');

        current = (index + total) % total;

        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function start() {
        timer = setInterval(function () {
          goTo(current + 1);
        }, INTERVAL);
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }

      /* Dot click handlers */
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          stop();
          goTo(i);
          start();
        });
      });

      /* Arrow handlers */
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          stop();
          goTo(current - 1);
          start();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          stop();
          goTo(current + 1);
          start();
        });
      }

      /* Pause on hover / focus */
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('focusin',    stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusout',   start);

      /* Arrow key navigation when hero has focus */
      hero.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          stop();
          goTo(current - 1);
          start();
        } else if (e.key === 'ArrowRight') {
          stop();
          goTo(current + 1);
          start();
        }
      });

      /* Init */
      goTo(0);
      start();
    });
  })();


  /* ----------------------------------------------------------
     5. FAQ Accordion
     window.bffFaqToggle(btn)
  ---------------------------------------------------------- */
  (function () {
    window.bffFaqToggle = function (btn) {
      if (!btn) return;

      var section  = btn.closest('.faq-section');
      var item     = btn.closest('.faq-item');
      var body     = item ? item.querySelector('.faq-body') : null;
      if (!body) return;

      var isOpen = item.classList.contains('is-open');

      /* Close all open items in this section */
      if (section) {
        section.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
          if (openItem === item) return;
          var openBody = openItem.querySelector('.faq-body');
          var openBtn  = openItem.querySelector('.faq-trigger');
          openItem.classList.remove('is-open');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
          if (openBody) {
            openBody.classList.remove('is-open');
            setTimeout(function () { openBody.hidden = true; }, 300);
          }
        });
      }

      /* Toggle clicked item */
      if (isOpen) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        body.classList.remove('is-open');
        setTimeout(function () { body.hidden = true; }, 300);
      } else {
        body.hidden = false;
        /* Allow hidden removal to paint before adding .is-open for transition */
        requestAnimationFrame(function () {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          body.classList.add('is-open');
        });
      }
    };
  })();


  /* ----------------------------------------------------------
     6. Footer Mobile Accordion
     window.bffFooterAcc(btn)
  ---------------------------------------------------------- */
  (function () {
    window.bffFooterAcc = function (btn) {
      if (!btn) return;
      var list = btn.nextElementSibling;
      if (!list) return;

      var isOpen = list.classList.contains('is-open');
      list.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    };
  })();

});
